import RegionSummaryApiClient from "api/RegionSummaryApiClient";
import { useBuildReport } from "hooks/reports/useBuildReport";
import { ReportFormat } from "api/Enums";

export function useGenerateRegionSummary(options) {
    return useBuildReport(
        (regionId) => RegionSummaryApiClient.buildRegionSummary(regionId, ReportFormat.Json),
        options,
    );
}
